// extracted by mini-css-extract-plugin
export default {"table-container":"VirginProjectTemplatesTable_table-container__e8hFY"};